import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addContractType, deleteContractType, getAllContractType, updateContractType } from '../../redux/rtk/features/masters/contractTypeSlice';
import PageTitle from '../page-header/PageHeader';

const ContractTypeMaster = () => {
  const { Title } = Typography;
  const [editingContractType, setEditingContractType] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.contractType);

  useEffect(() => {
    dispatch(getAllContractType());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingContractType) {
        // Update existing contractType
        const result = await dispatch(
          updateContractType({ id: editingContractType.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllContractType());
        } else {
          message.error('Error updating contractType!');
        }
      } else {
        // Add new contractType
        const result = await dispatch(addContractType(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllContractType());
        } else {
          message.error('Error adding contract Type!');
        }
      }
      setEditingContractType(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update contractType!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteContractType(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllContractType()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Contract Type',
      dataIndex: 'contractType',
      key: 'contractType',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingContractType(record); form.setFieldsValue(record)}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this contract type?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
        <Card title={editingContractType ? 'Edit Contract Type' : 'Add Contract Type'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="contract-type-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="contractType"
            label="Contract Type"
            rules={[{ required: true, message: 'Please enter a contract type!' }]}
          >
            <Input placeholder="Enter contract type " />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingContractType ? 'Update Contract Type' : 'Add Contract Type'}
              </Button>
            </Form>
        </Card>
        </Col>
        <Col span={16}>
          <Card title="Contract Type List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
        </Row>
    </div>
  );
};

export default ContractTypeMaster;
